import {useLayoutEffect, useState} from 'react'
import {Layout} from '../../../layout'
import {Text} from '../../../text'
import {ColumnPicker} from '../../consumers'

const inlineStyles = {position: 'sticky', display: 'inline-flex', top: 0}

export const AdvancedTableShowMore = ({...rest}) => {
	const [height, setHeight] = useState(0)

	useLayoutEffect(() => {
		const pageBody = document.querySelector('.page-body')
		if (!pageBody) return

		const observer = new ResizeObserver(() => {
			setHeight(pageBody.clientHeight)
		})

		observer.observe(pageBody)
		setHeight(pageBody.clientHeight)

		return () => observer.disconnect()
	}, [])

	return (
		<Layout
			className="advanced-table-show-more"
			width={200}
			direction="vertical"
			vertical="center"
			horizontal="center"
			height={height}
			gap={16}
			style={inlineStyles}
		>
			<Text bold t="table.show_more_data" />
			<ColumnPicker {...rest} trigger={{t: 'common.column_plural', iconLeft: 'plus', colorSet: 'solid'}} />
		</Layout>
	)
}
